import { $auth } from '../store/store.js';

$auth.subscribe(({ email }) => {
  const emailListItem = document.getElementById('user-email');
  if (!emailListItem) return;
  emailListItem.innerText = email ?? '';
});

const signOutButton = document.getElementById('sign-out');
signOutButton?.addEventListener('click', () => {
  void Clerk.signOut();
});
